import Link from "next/link";
import { UrlObject } from "url";
import { Stack } from "@chakra-ui/react";
import { FiArrowUpRight } from "@onemind-services-llc/react-icons-ng/fi";
import { Text, Button } from "@/elements";

type ContentProps = {
  link?: string | UrlObject;
  text: string;
};

export const ContentWithTextAndLink = (props: ContentProps) => {
  const { link, text } = props;
  const textVariant = "body2";

  return (
    <Stack height={"100%"} justifyContent={"space-between"} gap={4}>
      <Text color={"text.100"} variant={textVariant} _groupHover={{ color: "white" }}>
        {text}
      </Text>
      {link && (
        <Button
          as={Link}
          cursor={"pointer"}
          href={link}
          variant={"link"}
          color="primary.200"
          _groupHover={{ backgroundColor: "white" }}
          w={"fit-content"}
          px={3}
          py={1.5}
        >
          <Text fontWeight={600} variant={textVariant}>
            Explore more
          </Text>
          <FiArrowUpRight fontSize={"24px"} />
        </Button>
      )}
    </Stack>
  );
};
